import request from "@/utils/request"

// 获取记账信息
export function getAccountInfo(params){
    return request({
        url: '/accountingInformation/getAccountingInformation',
        method: 'get',
        noShowLoading: true,
        params
    })
}

// 获取银行信息
export function getBankList(params){
    return request({
        url: '/books/selectBankInfo',
        method: 'get',
        noShowLoading: true,
        params
    })
}
// 保存信息
export function saveInfo (data) {
    return request({
        url:'/accountingInformation/save',
        method: "post",
        noShowLoading: true,
        data:data
    })
}
// 获取保存状态
export function getSaveStatus (params) {
    return request({
        url:'/accountingInformation/getTask',
        method: "get",
        noShowLoading: true,
        params
    })
}
// 保存凭证
export function saveVoucher (data) {
    return request({
        url:'/accountingInformation/saveVoucher',
        method: "post",
        data:data
    })
}

// 取消制单
export function cancleMakeOrder (data) {
    return request({
        url:'v2/accountingInformation/cancel',
        method: "post",
        data:data
    })
}

// 删除图片
export function delImage (data) {
    return request({
        url:'/file/delete',
        method: "post",
        data:data
    })
}

//设置旋转角度
export function setImgAngle (data) {
    return request({
        url:'/file/setRotateAngle',
        method: "post",
        data:data,
        noShowLoading: true,
    })
}


// 图片上传完成接口
export function finishUpload (data) {
    return request({
        url:'/file/finishUpload',
        method: "post",
        data:data
    })
}

// 下载分隔页
export function downloadVoucher (params) {
    return request({
        url:'/accountingInformation/downloadAccountingInformation',
        method: "get",
        responseType:'arraybuffer',
        params
    })
}

// 获取第一步验证票据
export function getBillVerifyInfo(data){
    return request({
        url: '/v2/accountingInformation/billVerify',
        method: 'post',
        noShowLoading: true,
        data
    })
}